import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="104"
    height="138"
    viewBox="0 0 104 138"
    fill="none"
  >
    <g>
      <path
        d="M31.8503 53.6963H2.16699V112.827H31.8503V53.6963Z"
        fill="#FFD15C"
      />
      <path
        d="M31.8503 53.6963H2.16699V56.5224H31.8503V53.6963Z"
        fill="#F7B64C"
      />
      <path d="M34.0167 46.7393H0V53.9132H34.0167V46.7393Z" fill="#FFD15C" />
      <path
        d="M101.833 66.7393H72.1499V112.826H101.833V66.7393Z"
        fill="#F78471"
      />
      <path
        d="M101.833 66.7393H72.1499V69.5654H101.833V66.7393Z"
        fill="#F05540"
      />
      <path d="M104 59.7822H69.9834V66.9561H104V59.7822Z" fill="#F78471" />
      <path
        d="M18.8503 74.7834C19.5003 73.9138 19.717 73.2616 19.717 72.3922C19.717 71.5228 19.5003 71.0879 19.067 70.4357C18.6337 70.001 17.9837 69.5661 17.117 69.5661C15.6003 69.5661 14.3003 70.6529 13.0003 72.6095L8.66699 70.4355C9.75026 68.6964 10.8335 67.6095 12.1335 66.7399C13.4335 65.8703 14.9503 65.4355 17.1168 65.4355C19.0668 65.4355 20.8001 66.0877 22.3168 67.3921C23.8335 68.6964 24.4835 70.4355 24.4835 72.6095C24.4835 73.6963 24.2668 75.0007 23.6168 76.0878C22.9668 77.1747 21.8835 78.479 20.3668 80.2183L16.2503 84.566H25.3503V89.1313H9.10026V85.2182L15.817 78.2618C17.117 76.74 18.2003 75.6531 18.8503 74.7834Z"
        fill="white"
      />
      <path
        d="M80.1672 82.6095V78.2617H94.2505V81.9573L89.4837 87.3922C91.217 87.6096 92.7337 88.479 93.817 89.7834C94.9002 91.0877 95.3337 92.3921 95.3337 94.1311C95.3337 96.5224 94.467 98.4789 92.9505 99.7833C91.2172 101.088 89.2672 101.74 86.6672 101.74C84.0672 101.74 81.4672 100.87 78.8672 99.1311L81.0337 95.0008C83.2005 96.5226 85.1505 97.392 86.8837 97.392C87.967 97.392 88.8337 97.1746 89.4837 96.7398C90.1337 96.3051 90.567 95.4355 90.567 94.5659C90.567 93.6962 90.1337 92.8268 89.4837 92.3919C88.617 91.7397 87.7505 91.5222 86.2337 91.5222C85.5837 91.5222 84.5005 91.7397 83.2005 92.1744V88.479L87.5337 83.2616H80.167V82.6095H80.1672Z"
        fill="white"
      />
      <path
        d="M66.9499 31.9561H37.2666V112.826H66.9499V31.9561Z"
        fill="#95D6A4"
      />
      <path
        d="M66.9499 31.9561H37.2666V34.7822H66.9499V31.9561Z"
        fill="#4ABAA5"
      />
      <path d="M68.9 25H34.8833V32.1739H68.9V25Z" fill="#95D6A4" />
      <path
        d="M47.4502 43.4785H56.7669V66.5221H51.7837V47.8265H47.4502V43.4785Z"
        fill="white"
      />
    </g>
  </SvgIcon>
));
